import Logger from './logger';

const LoggerFactory = {
  createLogger: (options) => new Logger(options),
};

export default LoggerFactory;
